import Icon from '../components/Icon.vue'

Icon.register({
  'mail-bulk': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M160 448C134.4 448 108.8 425.6 96 416 32 371.2 12.8 355.2 0 345.6V480C0 497.7 14.3 512 32 512H288C305.7 512 320 497.7 320 480V345.6C307.2 355.2 288 371.2 224 416 211.2 425.6 185.6 448 160 448zM288 256H32C14.3 256 0 270.3 0 288V304C25.6 323.2 22.4 323.2 115.2 390.4 124.8 396.8 144 416 160 416S195.2 396.8 204.8 393.6C297.6 326.4 294.4 326.4 320 307.2V288C320 270.3 305.7 256 288 256zM544 160H224C206.3 160 192 174.3 192 192V224H288C321.2 224 348.6 249.4 351.7 281.8L352 281.6V416H544C561.7 416 576 401.7 576 384V192C576 174.3 561.7 160 544 160zM512 288H448V224H512V288zM160 192C160 156.7 188.7 128 224 128H448V32C448 14.3 433.7 0 416 0H96C78.3 0 64 14.3 64 32V224H160V192z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/mail-bulk.js
// module id = Cr6+
// module chunks = 144